import React, { Component } from 'react';
import XIcon from './XIcon';
import StarIcon from '../../HOME/SVG/StarIcon';
import { delay } from '../../HOME/utils';
import { TWISTED } from '../const';

class Cell extends Component {
  constructor(props) {
    super(props);

    if (!props) {
      return;
    }

    const { row, col } = props.cell;

    this.area = `${row}/${col}`;
    this.translate = `translate(${1 - col}px, ${1 - row}px)`;
  }

  handleTouch = () => {
    this.touch = true;
    this.handleClick();
  };

  handleMouseDown = () => {
    if (!this.touch) {
      this.handleClick();
    }
  };

  handleClick = () => {
    const { board, cell } = this.props;

    board.props.showHelp(false);

    if (board.props.paused) {
      return;
    }

    if (board.gameOver()) {
      if (!board.blocked) {
        board.restart();
      }

      return;
    }

    if (cell.exposed) {
      return;
    }

    this.expose(true);

    if (cell.star) {
      board.onHit();
    } else {
      board.onMiss();

      delay(() => {
        this.expose(false);
      });
    }
  };

  expose = yes => {
    const { cell } = this.props;

    cell.exposed = yes;
    this.forceUpdate();
  };

  renderExposed = () => {
    const { width, cell, board } = this.props;
    const onWidth = width * 0.65;
    const offWidth = width * 0.45;
    const cls = `${
      board.gameOver()
        ? ''
        : board.props.mode === TWISTED
        ? board.clockwise
          ? 'mt-twist-counter-clockwise'
          : 'mt-twist-clockwise'
        : board.clockwise
        ? 'mt-twist-clockwise'
        : 'mt-twist-counter-clockwise'
    }`;
    const dur = `${cell.dur}s`;

    return cell.star ? (
      <span className={cls} style={{ animationDuration: dur }}>
        <StarIcon width={onWidth} color="yellow" color2="orange" />
      </span>
    ) : (
      <XIcon width={offWidth} />
    );
  };

  render() {
    const { board, width, cell } = this.props;

    return (
      <div style={{ width, gridArea: this.area, transform: this.translate }}>
        <div
          className="tt-cell"
          style={{ height: width, display: 'grid', alignContent: 'center', justifyContent: 'center' }}
          onTouchStart={() => this.handleTouch(false)}
          onMouseDown={() => this.handleMouseDown(false)}>
          {cell.exposed && !board.props.paused ? this.renderExposed() : null}
        </div>
      </div>
    );
  }
}

export default Cell;
